import { attributePrefix } from '../../../config/productFilters';
import { AttributeCode } from '../state/attributeCode';
import { pipe, Schema, String as Str, SchemaGetter } from 'effect';

const extractPrefix =
  (prefix: string) =>
  (str: string): string =>
    Str.startsWith(prefix)(str) ? Str.slice(prefix.length)(str) : str;

export const matchAttributePattern = (pattern: RegExp) => (key: string) =>
  pipe(key, Str.match(pattern));

export const prefixAttribute = (code: string) => pipe(attributePrefix, Str.concat(code));

export const extractAttributeCode = extractPrefix(attributePrefix);

export const PrefixedAttributeCode = Schema.TemplateLiteral([attributePrefix, AttributeCode]);

export const AttributeCodeWithPrefix = AttributeCode.pipe(
  Schema.decodeTo(Schema.String, {
    decode: SchemaGetter.transform(prefixAttribute),
    encode: SchemaGetter.transform(extractAttributeCode),
  })
);
